import { startTransition, useEffect, useState } from 'react';
import { useResizeDimensions } from './useResizeDimensions';

/**
 * A custom hook that returns the number of pixels the content is scrolled
 * out of the bound of the container
 *
 * @param {import('react').RefObject<HTMLElement>} containerRef
 */
export function useOverscroll(containerRef) {
  const [scrollX, setScrollX] = useState(0);
  const [scrollY, setScrollY] = useState(0);

  const dimensions = useResizeDimensions(containerRef);

  useEffect(() => {
    if (!containerRef.current) return undefined;

    const element = containerRef.current;

    /** */
    function updateScroll() {
      startTransition(() => {
        setScrollX(element.scrollLeft);
        setScrollY(element.scrollTop);
      });
    }

    element.addEventListener('scroll', updateScroll);
    updateScroll();

    return () => {
      element.removeEventListener('scroll', updateScroll);
    };
  }, [containerRef]);

  const right = dimensions.scrollWidth !== undefined && dimensions.clientWidth !== undefined
    ? dimensions.scrollWidth - dimensions.clientWidth - scrollX
    : undefined;
  const bottom = dimensions.scrollHeight !== undefined && dimensions.clientHeight !== undefined
    ? dimensions.scrollHeight - dimensions.clientHeight - scrollY
    : undefined;

  return {
    left: scrollX,
    top: scrollY,
    right,
    bottom,
  };
}
